import { render, staticRenderFns } from "./MarketplaceAdminCard.vue?vue&type=template&id=21656330&scoped=true"
import script from "./MarketplaceAdminCard.vue?vue&type=script&lang=ts"
export * from "./MarketplaceAdminCard.vue?vue&type=script&lang=ts"
import style0 from "./MarketplaceAdminCard.vue?vue&type=style&index=0&id=21656330&scoped=true&lang=scss"
import style1 from "./MarketplaceAdminCard.vue?vue&type=style&index=1&id=21656330&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21656330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21656330')) {
      api.createRecord('21656330', component.options)
    } else {
      api.reload('21656330', component.options)
    }
    module.hot.accept("./MarketplaceAdminCard.vue?vue&type=template&id=21656330&scoped=true", function () {
      api.rerender('21656330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/marketplace/MarketplaceAdminCard.vue"
export default component.exports